export default __webpack_public_path__ + "static/media/fan-galleries2.558adefc.jpg";